// test134
(134 && 0);
